import { render, staticRenderFns } from "./CalendarField.vue?vue&type=template&id=24d2078f&scoped=true&"
import script from "./CalendarField.vue?vue&type=script&lang=js&"
export * from "./CalendarField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2078f",
  null
  
)

export default component.exports